import api from '@/api';
import MobileDashboardRequest from '@/model/Dashboard/MobileDashboardRequest';

/**
 * Mobile Super Dashboard.
 * `filter` is kept in the store so the selection survives navigating to a
 * detail screen and back within the session (fresh sessions default to
 * "This Month" — set by the view).
 */
export default {
  namespaced: true,
  state: {
    filter: null,
  },
  getters: {
    filter: state => state.filter,
  },
  mutations: {
    setFilter(state, filter) {
      state.filter = filter;
    },
  },
  actions: {
    getSummary(actions, filter) {
      return api.base()
        .post('/dashboard/mobile/summary', MobileDashboardRequest(filter))
        .then(response => response.data.data);
    },
    getRankings(actions, filter) {
      return api.base()
        .post('/dashboard/mobile/rankings', MobileDashboardRequest(filter))
        .then(response => response.data.data);
    },
    // Per-desk drill: filter.desks carries the tapped desk's name.
    getDeskAgents(actions, filter) {
      return api.base()
        .post('/dashboard/mobile/desk-agents', MobileDashboardRequest(filter))
        .then(response => response.data.data);
    },
  },
};
